import { createSlice } from "@reduxjs/toolkit";
import { setFeedback } from "./feedbackSlice";
import api from "../../components/common/commonfunctionforapi";

const initialState = {
  isLoading: false,
  success: false,
  error: null,
};

const createSettingSlice = createSlice({
  name: "createSetting",
  initialState,
  reducers: {
    createSettingStart: (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    },
    createSettingSuccess: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
    },
    createSettingFailure: (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.payload;
    },
  },
});

export const {
  createSettingStart,
  createSettingSuccess,
  createSettingFailure,
} = createSettingSlice.actions;

export default createSettingSlice.reducer;

export const createSetting = (settingData) => async (dispatch) => {
  try {
    dispatch(createSettingStart());

    const response = await api({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/assignee_setting`,
      data: settingData,
    });

    const data = response.data;
    // console.log(response.data, "lead slice");
    dispatch(createSettingSuccess());
    // successToast("Lead creatde successfully!");
    return { success: true, message: data.message };
  } catch (error) {
    dispatch(createSettingFailure(error.message));
    dispatch(
      setFeedback({
        status: "fail",
        message: error.response.data.message,
        code: error.response.status_code,
      })
    );
    return { success: false, error: error.response.message };
  }
};
